import { useEffect, useState } from 'react';
import type { TextField } from '@aquilixshop/ui-react';
import { FieldRow } from '../FieldRow';

/**
 * Single-line text. Debounced store write (coalesces undo + re-renders, build-plan §6.2); flushes on
 * blur. Stored/rendered as plain text — React escapes it, no sanitize needed (build-plan §6.3).
 */
export function TextControl({
  field,
  value,
  onChange,
}: {
  field: TextField;
  value: string | undefined;
  onChange: (next: string) => void;
}) {
  const [local, setLocal] = useState(value ?? '');
  useEffect(() => setLocal(value ?? ''), [value]);

  const counter = field.maxLength ? `${local.length}/${field.maxLength}` : undefined;

  return (
    <FieldRow id={field.id} label={field.label} info={field.info} counter={counter}>
      <input
        id={field.id}
        className="bld-input"
        type="text"
        value={local}
        placeholder={field.placeholder}
        maxLength={field.maxLength}
        onChange={(e) => {
          setLocal(e.target.value);
          onChange(e.target.value);
        }}
      />
    </FieldRow>
  );
}
